import { Feature } from '../../../constants/feature';
import { title, titleWebview } from '../../../constants/titles';
import { useWidgetContext } from '../../../hooks/use-widget-context';
export const useTitle = () => {
    const { displayPanel, hasFeature, isPreAuth, isWebview } = useWidgetContext();
    const withBackCall = hasFeature(Feature.BackCallButton) && !isWebview && !isPreAuth;
    const getTitle = () => {
        if (displayPanel === 'voip') {
            return isWebview ? titleWebview[displayPanel] : title[displayPanel];
        }
        if (withBackCall) {
            return title.otherContactsWithBackCallButtonFeat;
        }
        return title[displayPanel];
    };
    return {
        title: getTitle(),
        titleButtonOtherContacts: withBackCall
            ? title.otherContactsWithBackCallButtonFeat
            : title.otherContacts,
    };
};
